// extracted by mini-css-extract-plugin
module.exports = {"headerRow":"PageHeader_headerRow__6jXfP","pageTitle":"PageHeader_pageTitle__jeJtj","pageSubtitle":"PageHeader_pageSubtitle__3W9lf"};